var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRomaniaFingerprint(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "343 0 338 559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 408 481 L 411 485 L 426 489 L 425 483 L 412 479 Z",
    fill: "#002B7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 391 462 L 395 467 L 426 477 L 426 472 L 394 460 Z",
    fill: "#002B7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 377 444 L 380 448 L 426 464 L 426 459 L 382 442 Z",
    fill: "#002B7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 370 428 L 370 432 L 384 434 L 426 450 L 425 444 L 384 429 Z",
    fill: "#002B7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 365 414 L 365 419 L 380 419 L 394 422 L 426 435 L 426 429 L 408 421 L 388 415 Z",
    fill: "#002B7F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 360 404 L 361 407 L 391 406 L 399 408 L 426 421 L 425 414 L 405 404 L 393 401 L 363 401 Z",
    fill: "#002B7F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 376 395 L 400 393 L 426 406 L 426 400 L 402 388 L 385 388 L 378 390 Z",
    fill: "#002B7F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 398 356 L 396 356 L 393 363 L 380 377 L 369 385 L 357 390 L 356 394 L 365 393 L 386 379 L 398 364 Z",
    fill: "#002B7F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 407 339 L 404 347 L 404 365 L 407 375 L 395 377 L 393 382 L 406 381 L 420 391 L 425 392 L 426 389 L 411 373 L 409 365 L 410 340 Z",
    fill: "#002B7F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 405 298 L 402 298 L 379 340 L 363 358 L 351 366 L 351 371 L 359 368 L 369 360 L 383 344 L 406 302 Z",
    fill: "#002B7F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 427 296 L 425 296 L 422 302 L 415 331 L 416 360 L 426 383 L 427 374 L 421 359 L 419 345 Z",
    fill: "#002B7F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 426 271 L 393 342 L 385 354 L 369 370 L 353 379 L 354 384 L 375 372 L 385 362 L 399 342 L 426 283 Z",
    fill: "#002B7F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 426 247 L 366 335 L 347 354 L 348 357 L 352 357 L 375 332 L 394 301 L 427 255 Z",
    fill: "#002B7F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 426 223 L 410 232 L 397 245 L 343 319 L 344 323 L 348 322 L 399 251 L 413 236 L 419 233 L 417 242 L 384 284 L 359 322 L 345 337 L 346 341 L 350 340 L 359 331 L 382 296 L 415 254 L 424 239 Z",
    fill: "#002B7F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 426 204 L 412 214 L 387 238 L 343 295 L 344 299 L 348 298 L 366 272 L 398 234 L 426 210 Z",
    fill: "#002B7F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 426 186 L 406 200 L 377 229 L 346 266 L 347 272 L 351 270 L 363 253 L 407 206 L 426 192 Z",
    fill: "#002B7F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 426 170 L 412 177 L 392 193 L 348 243 L 348 246 L 352 247 L 372 222 L 398 195 L 425 176 Z",
    fill: "#002B7F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 426 154 L 407 164 L 381 184 L 362 204 L 353 219 L 357 220 L 366 207 L 395 179 L 426 160 Z",
    fill: "#002B7F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 426 138 L 392 158 L 362 182 L 360 186 L 364 188 L 403 157 L 425 145 Z",
    fill: "#002B7F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 426 123 L 386 146 L 366 162 L 367 165 L 371 165 L 401 142 L 424 130 Z",
    fill: "#002B7F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 426 107 L 395 123 L 376 138 L 381 140 L 399 127 L 426 113 Z",
    fill: "#002B7F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 426 92 L 400 104 L 387 114 L 392 116 L 424 98 Z",
    fill: "#002B7F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 426 76 L 408 83 L 403 89 L 408 90 L 426 81 Z",
    fill: "#002B7F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 565 509 L 539 511 L 537 514 L 539 516 L 565 513 Z",
    fill: "#FCD116"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 595 492 L 553 500 L 511 504 L 461 503 L 432 498 L 431 502 L 459 508 L 514 509 L 580 501 L 595 497 Z",
    fill: "#FCD116"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 595 481 L 518 491 L 473 491 L 429 484 L 429 489 L 472 496 L 520 496 L 582 489 L 595 486 Z",
    fill: "#FCD116"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 429 472 L 430 478 L 447 483 L 451 480 L 450 478 Z",
    fill: "#FCD116"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 462 L 430 466 L 453 475 L 496 484 L 545 483 L 595 474 L 595 469 L 543 478 L 497 479 L 465 473 L 430 460 Z",
    fill: "#FCD116"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 429 447 L 429 452 L 450 461 L 481 470 L 503 473 L 547 472 L 595 462 L 595 457 L 551 466 L 505 468 L 470 462 Z",
    fill: "#FCD116"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 432 L 429 437 L 465 453 L 506 462 L 538 462 L 595 451 L 595 445 L 544 456 L 501 456 L 479 452 L 461 446 L 430 431 Z",
    fill: "#FCD116"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 417 L 429 423 L 441 431 L 447 432 L 446 427 Z",
    fill: "#FCD116"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 403 L 429 409 L 459 433 L 481 446 L 492 450 L 497 449 L 495 445 L 473 436 L 434 405 Z",
    fill: "#FCD116"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 595 380 L 574 398 L 561 404 L 546 406 L 543 409 L 544 411 L 555 411 L 576 403 L 595 387 Z",
    fill: "#FCD116"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 429 378 L 428 385 L 430 389 L 451 411 L 478 432 L 508 446 L 531 450 L 551 449 L 575 443 L 595 433 L 594 428 L 573 438 L 549 444 L 524 444 L 511 441 L 485 430 L 468 418 L 439 391 Z",
    fill: "#FCD116"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 442 306 L 439 317 L 439 342 L 445 363 L 455 379 L 475 400 L 493 413 L 520 425 L 537 427 L 538 424 L 536 422 L 525 421 L 508 415 L 485 401 L 458 374 L 445 346 L 444 319 L 446 309 Z",
    fill: "#FCD116"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 472 301 L 474 322 L 483 348 L 496 367 L 515 382 L 532 389 L 551 390 L 571 384 L 583 378 L 594 369 L 595 359 L 577 375 L 550 385 L 531 383 L 515 376 L 500 363 L 490 350 L 480 325 L 477 301 Z",
    fill: "#FCD116"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 475 265 L 464 290 L 462 320 L 469 348 L 485 374 L 510 394 L 531 401 L 555 400 L 579 389 L 578 385 L 550 396 L 532 396 L 510 388 L 489 370 L 474 346 L 468 325 L 467 306 L 469 292 L 478 267 Z",
    fill: "#FCD116"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 593 250 L 591 254 L 595 261 L 595 251 Z",
    fill: "#FCD116"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 501 231 L 484 240 L 472 251 L 461 266 L 454 281 L 450 301 L 450 325 L 456 351 L 472 379 L 483 391 L 499 403 L 531 414 L 544 421 L 562 421 L 575 417 L 594 406 L 595 399 L 573 412 L 559 416 L 547 416 L 533 409 L 514 404 L 498 396 L 479 379 L 470 367 L 461 349 L 455 323 L 455 302 L 461 278 L 470 262 L 483 248 L 496 239 L 507 235 L 529 237 L 540 243 L 549 252 L 562 276 L 566 304 L 562 316 L 556 323 L 549 326 L 538 323 L 526 307 L 524 289 L 526 287 L 529 289 L 533 307 L 540 315 L 544 317 L 553 315 L 558 306 L 559 296 L 551 269 L 544 258 L 535 249 L 526 244 L 509 243 L 497 248 L 488 258 L 483 270 L 482 302 L 488 329 L 501 353 L 513 365 L 527 373 L 536 376 L 555 376 L 579 365 L 595 346 L 595 334 L 586 350 L 575 361 L 553 371 L 531 369 L 517 361 L 503 347 L 493 327 L 487 301 L 487 277 L 490 266 L 496 256 L 507 249 L 520 248 L 531 253 L 546 271 L 553 291 L 553 304 L 547 312 L 539 306 L 535 289 L 531 283 L 522 282 L 518 287 L 521 309 L 527 320 L 539 330 L 553 331 L 564 323 L 570 310 L 571 292 L 562 262 L 545 240 L 526 230 L 510 229 Z",
    fill: "#FCD116"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 510 214 L 493 219 L 472 232 L 456 249 L 445 266 L 429 313 L 429 358 L 435 373 L 446 389 L 483 421 L 499 430 L 519 437 L 552 437 L 588 424 L 595 419 L 595 414 L 568 427 L 546 433 L 526 433 L 508 428 L 484 415 L 450 385 L 439 369 L 432 346 L 432 329 L 437 303 L 445 279 L 455 260 L 465 247 L 484 230 L 495 224 L 513 219 L 534 222 L 546 229 L 557 240 L 573 268 L 579 297 L 575 321 L 562 338 L 548 343 L 534 339 L 524 330 L 517 318 L 512 300 L 513 279 L 519 271 L 529 271 L 536 278 L 543 303 L 547 302 L 546 290 L 541 276 L 530 265 L 519 265 L 511 271 L 507 281 L 507 302 L 516 328 L 530 343 L 543 348 L 551 348 L 563 344 L 576 331 L 583 313 L 584 292 L 580 272 L 570 249 L 561 236 L 546 222 L 526 214 Z",
    fill: "#FCD116"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 462 211 L 455 214 L 437 232 L 429 243 L 429 252 L 448 228 L 463 216 Z",
    fill: "#FCD116"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 483 207 L 464 221 L 443 245 L 429 267 L 429 277 L 460 233 L 482 214 L 498 207 L 510 205 L 530 207 L 545 213 L 568 232 L 576 243 L 584 261 L 591 290 L 591 307 L 584 331 L 578 341 L 568 351 L 554 357 L 534 355 L 517 343 L 508 330 L 503 318 L 499 285 L 504 268 L 509 262 L 518 258 L 518 254 L 512 254 L 504 259 L 496 272 L 494 283 L 496 314 L 507 339 L 526 357 L 539 362 L 551 363 L 570 356 L 585 340 L 595 313 L 594 277 L 588 256 L 580 239 L 561 217 L 535 203 L 507 200 Z",
    fill: "#FCD116"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 221 L 428 226 L 430 227 L 451 210 L 480 197 L 500 192 L 526 192 L 543 197 L 561 207 L 595 241 L 594 231 L 573 209 L 554 196 L 529 187 L 499 187 L 469 195 L 447 206 Z",
    fill: "#FCD116"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 577 185 L 576 188 L 595 202 L 595 195 L 581 185 Z",
    fill: "#FCD116"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 204 L 429 208 L 462 189 L 485 181 L 499 178 L 523 177 L 543 181 L 557 187 L 572 197 L 595 220 L 593 209 L 572 190 L 553 179 L 527 172 L 504 172 L 473 179 L 438 195 Z",
    fill: "#FCD116"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 185 L 430 190 L 464 174 L 491 166 L 506 164 L 528 164 L 549 168 L 578 178 L 594 187 L 595 181 L 580 173 L 551 163 L 531 159 L 502 159 L 456 171 Z",
    fill: "#FCD116"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 168 L 428 173 L 431 173 L 459 160 L 497 150 L 522 149 L 559 156 L 595 172 L 594 165 L 578 157 L 558 150 L 527 144 L 503 144 L 484 147 L 457 155 Z",
    fill: "#FCD116"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 153 L 430 158 L 474 141 L 503 135 L 524 134 L 567 143 L 595 156 L 594 149 L 572 139 L 543 131 L 508 129 L 480 134 L 453 142 Z",
    fill: "#FCD116"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 137 L 429 143 L 452 133 L 480 125 L 497 122 L 533 122 L 564 128 L 595 140 L 595 134 L 573 125 L 543 118 L 521 116 L 496 117 L 473 121 Z",
    fill: "#FCD116"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 122 L 428 127 L 447 119 L 483 109 L 527 107 L 558 112 L 595 125 L 595 119 L 586 115 L 551 105 L 530 102 L 495 102 L 476 105 L 448 113 Z",
    fill: "#FCD116"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 107 L 428 111 L 474 96 L 503 92 L 549 95 L 595 109 L 595 104 L 575 96 L 550 90 L 526 87 L 499 87 L 453 96 Z",
    fill: "#FCD116"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 91 L 428 95 L 432 95 L 454 86 L 479 80 L 520 77 L 556 82 L 595 95 L 595 89 L 580 83 L 548 75 L 522 72 L 491 73 L 467 77 L 437 86 Z",
    fill: "#FCD116"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M 428 75 L 428 79 L 432 79 L 442 74 L 472 66 L 495 63 L 525 63 L 562 69 L 595 79 L 594 73 L 549 61 L 525 58 L 476 60 L 446 67 Z",
    fill: "#FCD116"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M 435 59 L 439 62 L 472 51 L 511 47 L 543 50 L 575 58 L 585 63 L 589 61 L 585 56 L 559 48 L 514 42 L 475 45 L 451 51 Z",
    fill: "#FCD116"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M 609 489 L 597 491 L 596 496 L 607 494 L 610 491 Z",
    fill: "#CE1126"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M 626 473 L 599 479 L 596 481 L 597 485 L 624 478 Z",
    fill: "#CE1126"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M 640 458 L 636 456 L 597 468 L 597 473 L 631 464 Z",
    fill: "#CE1126"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M 649 442 L 646 440 L 598 456 L 596 461 L 598 462 L 647 446 Z",
    fill: "#CE1126"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M 658 423 L 655 422 L 619 438 L 597 444 L 596 450 L 641 435 L 657 427 Z",
    fill: "#CE1126"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M 664 407 L 662 405 L 612 429 L 611 432 L 613 434 L 662 411 Z",
    fill: "#CE1126"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M 667 391 L 656 393 L 596 427 L 596 432 L 608 427 L 638 408 L 665 396 L 668 393 Z",
    fill: "#CE1126"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M 668 378 L 663 378 L 642 390 L 642 395 L 666 383 Z",
    fill: "#CE1126"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M 655 365 L 653 376 L 657 377 L 660 369 L 658 365 Z",
    fill: "#CE1126"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M 650 355 L 646 355 L 645 368 L 637 384 L 625 395 L 597 412 L 597 419 L 623 403 L 639 390 L 649 373 Z",
    fill: "#CE1126"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M 639 336 L 636 337 L 637 350 L 633 369 L 616 390 L 618 395 L 628 386 L 639 368 L 642 354 L 642 344 Z",
    fill: "#CE1126"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M 609 331 L 606 332 L 603 345 L 596 358 L 596 365 L 602 359 L 607 349 L 611 335 Z",
    fill: "#CE1126"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M 618 315 L 615 317 L 616 338 L 614 350 L 607 365 L 596 378 L 596 385 L 610 370 L 618 354 L 621 333 L 620 317 Z",
    fill: "#CE1126"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M 615 280 L 612 280 L 611 284 L 624 317 L 626 347 L 619 370 L 608 386 L 597 396 L 596 404 L 610 392 L 620 379 L 626 367 L 631 349 L 629 316 Z",
    fill: "#CE1126"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M 596 252 L 596 264 L 600 273 L 604 294 L 603 314 L 596 332 L 596 343 L 604 328 L 609 307 L 607 279 Z",
    fill: "#CE1126"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M 596 235 L 596 242 L 621 280 L 651 347 L 666 369 L 672 372 L 673 368 L 658 349 L 626 278 L 610 252 Z",
    fill: "#CE1126"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M 641 217 L 642 223 L 664 251 L 675 270 L 679 272 L 681 269 L 663 240 L 644 217 Z",
    fill: "#CE1126"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M 596 214 L 597 223 L 611 240 L 632 274 L 672 354 L 676 355 L 677 351 L 666 333 L 636 270 L 615 236 Z",
    fill: "#CE1126"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M 597 197 L 597 204 L 616 224 L 656 290 L 676 334 L 679 334 L 679 326 L 672 310 L 639 250 L 615 214 Z",
    fill: "#CE1126"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M 597 182 L 596 188 L 609 197 L 630 222 L 666 280 L 675 299 L 679 301 L 681 299 L 674 283 L 631 214 L 615 195 Z",
    fill: "#CE1126"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M 597 167 L 598 174 L 631 197 L 650 215 L 673 242 L 677 242 L 677 238 L 637 195 Z",
    fill: "#CE1126"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M 597 151 L 597 157 L 631 179 L 667 213 L 672 211 L 663 200 L 636 176 Z",
    fill: "#CE1126"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M 597 135 L 597 141 L 633 162 L 661 187 L 665 186 L 665 183 L 641 161 L 612 142 Z",
    fill: "#CE1126"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M 597 120 L 597 126 L 627 141 L 653 160 L 657 160 L 658 157 L 634 139 Z",
    fill: "#CE1126"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M 597 105 L 598 111 L 622 122 L 643 135 L 646 133 L 644 129 L 631 121 Z",
    fill: "#CE1126"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M 597 90 L 598 96 L 633 113 L 636 112 L 634 107 Z",
    fill: "#CE1126"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M 597 75 L 598 81 L 618 88 L 617 83 Z",
    fill: "#CE1126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomaniaFingerprint);
export default __webpack_public_path__ + "static/media/romania_fingerprint.e5af6953c7e653431317d8ae1ea4d0fa.svg";
export { ForwardRef as ReactComponent };